<template>
  <div class="popup-main">
    <el-dialog title="写跟进" width="580px" :visible.sync="selfShow" :close-on-click-modal="false">
      <div>
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfData" />
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    const typeList = [
      { value: '打电话' },
      { value: '发微信' },
      { value: '上门拜访' },
      { value: '其他' }
    ]
    return {
      selfShow: false,
      selfData: {
        customer_uuid: this.detail.company_uuid,
        type: '',
        bei_zhu: '',
        jie_tu_list: []
      },
      formConfig: {
        inline: false,
        width: '100%'
      },
      formColumn: [
        {
          type: 'autocomplete',
          title: '跟进类型',
          field: 'type',
          querySearch(keyword, cb) {
            let createFilter = (keyword) => {
              return (restaurant) => {
                return restaurant.value.toLowerCase().indexOf(keyword.toLowerCase()) === 0
              }
            }
            let results = keyword ? typeList.filter(createFilter(keyword)) : typeList
            cb(results)
          },
          fnChange: () => {
            this.setVal()
          }
        },
        {
          type: 'textarea',
          title: '跟进备注',
          field: 'bei_zhu'
        },
        {
          type: 'upload_image',
          title: '跟进截图',
          field: 'jie_tu_list',
          size: '80px',
          isDelete: true
        }
      ],
      typeList
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
  },
  methods: {
    // 设置值
    setVal() {
      this.typeList.forEach((item) => {
        if (item.value === this.selfData.type) {
          this.selfData.type = item.value
        }
      })
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$refs.refForm.$refs.refForm.validate((valid) => {
        if (valid) {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/keHuGenZong/saveOrUpdate',
            data: this.selfData
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.popupCancel()
                this.$emit('success')
                this.$message.success('保存成功')
              }
            })
            .catch((error) => {
              this.$message.error(error)
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
